/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Rectangle } from './Rectangle';
import {
    RectangleFromJSON,
    RectangleFromJSONTyped,
    RectangleToJSON,
    RectangleToJSONTyped,
} from './Rectangle';

/**
 * 
 * @export
 * @interface VisualReference
 */
export interface VisualReference {
    /**
     * 
     */
    document_id: string;
    /**
     * 
     */
    document_name: string;
    /**
     * 
     */
    page_num: string;
    /**
     * 
     */
    text: string;
    /**
     * 
     */
    rect: Rectangle;
}

/**
 * Check if a given object implements the VisualReference interface.
 */
export function instanceOfVisualReference(value: object): value is VisualReference {
    if (!('document_id' in value) || value['document_id'] === undefined) return false;
    if (!('document_name' in value) || value['document_name'] === undefined) return false;
    if (!('page_num' in value) || value['page_num'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('rect' in value) || value['rect'] === undefined) return false;
    return true;
}

export function VisualReferenceFromJSON(json: any): VisualReference {
    return VisualReferenceFromJSONTyped(json, false);
}

export function VisualReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): VisualReference {
    if (json == null) {
        return json;
    }
    return {
        
        'document_id': json['document_id'],
        'document_name': json['document_name'],
        'page_num': json['page_num'],
        'text': json['text'],
        'rect': RectangleFromJSON(json['rect']),
    };
}

export function VisualReferenceToJSON(json: any): VisualReference {
    return VisualReferenceToJSONTyped(json, false);
}

export function VisualReferenceToJSONTyped(value?: VisualReference | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'document_id': value['document_id'],
        'document_name': value['document_name'],
        'page_num': value['page_num'],
        'text': value['text'],
        'rect': RectangleToJSON(value['rect']),
    };
}

